import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { CountableTimeZonePipe } from 'countable@helpers';


@Pipe({
    name: "timeago",
  pure: true,
  standalone: false
})
export class TimeAgoPipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private locale: string, private countableTimeZonePipe: CountableTimeZonePipe) { }

    transform(value: any, args?: any): any {
        if (value) {
            // Use a standardized date parsing approach
            let givenDate = new Date(value);
            if (isNaN(givenDate.getTime())) {
                // For Safari compatibility, convert to ISO 8601 format
                givenDate = new Date(value.replace(' ', 'T') + 'Z');
            }

            const currentUtcDate = new Date(this.countableTimeZonePipe.getTimeZoneUtcDate());
            const secondsDiff = Math.abs((currentUtcDate?.getTime() - givenDate.getTime()) / 1000);

            if (secondsDiff < 29 && args === "TB") {
                return 'Just now';
            }
            if (secondsDiff < 86400 && args === "CLIENT") {
                return this.countableTimeZonePipe.transform(value, 'HH:mm a', null);
            }

            const intervals = {
                'year': 31536000,
                'month': 2592000,
                'week': 604800,
                'day': 86400,
                'hour': 3600,
                'minute': 60,
                'second': 1
            };

            let counter;
            for (const i in intervals) {
                counter = Math.floor(secondsDiff / intervals[i]);
                if (counter > 0) {
                    return counter === 1 ? `${counter} ${i} ago` : `${counter} ${i}s ago`;
                }
            }
        }
        return value;
    }
}
